export const toolbar = ['fontselect | fontsizeselect | numlist bullist | mergeTagButton stbEmoji | removeformat | undo redo | alignleft aligncenter alignright alignjustify | bold italic underline strikethrough | stbForeColorPicker stbBackColorPicker | link stbUnlink']

export const content_style =
  `
body {}
`